<form [formGroup]="discountPeriodForm">
    <div class="modal-dialog modal-dialog-centered detail-modal">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Update Period Info.</h4>
                <button type="button" class="btn-close" aria-label="Close"
                    (click)="activeModal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <label for="discountType">Discount Type
                                        <span class="mandatory">*</span>
                                    </label>
                                    <ng-select id="discountType" placeholder="Select" [items]="discountTypeList"
                                        [appendTo]="'ngb-modal-window'" [openOnEnter]="false" formControlName="ddlDiscountType"
                                        (change)="onChangeDiscountType()"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || discountPeriodForm.get('ddlDiscountType').touched) && discountPeriodForm.get('ddlDiscountType').errors}" >
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || discountPeriodForm.get('ddlDiscountType').touched) && discountPeriodForm.get('ddlDiscountType').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="discountPeriodForm.get('ddlDiscountType').errors.required">Discount
                                            Type is Required</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4" *ngIf="isCategoryVisible">
                                <div class="mb-2">
                                    <label for="categoryType">Category <span class="mandatory">*</span></label>
                                    <ng-select id="categoryType" placeholder="Select" [items]="categoryList"
                                        [appendTo]="'ngb-modal-window'" [openOnEnter]="false" formControlName="ddlCategoryType"
                                        (change)="onChangeCategory()"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || discountPeriodForm.get('ddlCategoryType').touched) && discountPeriodForm.get('ddlCategoryType').errors}" >
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || discountPeriodForm.get('ddlCategoryType').touched) && discountPeriodForm.get('ddlCategoryType').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="discountPeriodForm.get('ddlCategoryType').errors.required">Discount
                                            Type is Required</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4" *ngIf="isCustomerVisible">
                                <div class="mb-2">
                                    <label for="customer">Customer <span class="mandatory">*</span></label>
                                    <ng-select id="customer" placeholder="Select" [items]="customerList"
                                        bindLabel="name" [bindValue]="'id'" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                        formControlName="ddlCustomer"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || discountPeriodForm.get('ddlCustomer').touched) && discountPeriodForm.get('ddlCustomer').errors}" >
                                        <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                            <span>{{ item.name }}</span>
                                        </ng-template>
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || discountPeriodForm.get('ddlCustomer').touched) && discountPeriodForm.get('ddlCustomer').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="discountPeriodForm.get('ddlCustomer').errors.required">Customer
                                            is Required</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <label for="fromDate" class="form-label">From Date <span
                                            class="mandatory">*</span></label>
                                    <input id="fromDate" class="form-control form-control-sm" type="date"
                                        formControlName="txtFromDate"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || discountPeriodForm.get('txtFromDate').touched) && discountPeriodForm.get('txtFromDate').errors}" >
                                    <div *ngIf="(isFormSubmitted || discountPeriodForm.get('txtFromDate').touched) && discountPeriodForm.get('txtFromDate').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="discountPeriodForm.get('txtFromDate').errors.required">Date is
                                            Required</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="mb-2">
                                    <label for="toDate" class="form-label">To Date <span
                                            class="mandatory">*</span></label>
                                    <input id="toDate" class="form-control form-control-sm" type="date"
                                        formControlName="txtToDate"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || discountPeriodForm.get('txtToDate').touched) && discountPeriodForm.get('txtToDate').errors}" >
                                    <div *ngIf="(isFormSubmitted || discountPeriodForm.get('txtToDate').touched) && discountPeriodForm.get('txtToDate').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="discountPeriodForm.get('txtToDate').errors.required">Date is
                                            Required</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" *ngIf="showBands">
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <label for="bands" class="form-label">Bands <span class="mandatory">*</span></label>
                                    <ng-select id="bands" [items]="bandsList" placeholder="Select"
                                        [appendTo]="'ngb-modal-window'" [openOnEnter]="false" formControlName="ddlBands"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || discountPeriodForm.get('ddlBands').touched) && discountPeriodForm.get('ddlBands').errors}" >
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || discountPeriodForm.get('ddlBands').touched) && discountPeriodForm.get('ddlBands').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="discountPeriodForm.get('ddlBands').errors.required">Rate
                                            Band is
                                            Required</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" *ngIf="showAccordingDiscountOnAmount">
                            <div class="col-md-2">
                                <div class="mb-3">
                                    <label for="fuel" class="form-label">Fuel</label>
                                    <div class="form-check form-switch form-switch-md">
                                        <input type="checkbox" class="form-check-input" formControlName="switchFuel" >
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="mb-3">
                                    <label for="freight" class="form-label">Freight</label>
                                    <div class="form-check form-switch form-switch-md mb-2">
                                        <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                            formControlName="switchFreight" >
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="mb-3">
                                    <label for="othercharges" class="form-label">Other Charges</label>
                                    <div class="form-check form-switch form-switch-md mb-2">
                                        <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                            formControlName="switchOtherCharges" >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" *ngIf="showAccordingDiscountOnWeight">
                            <div class="col-md-1">
                                <div class="mb-3">
                                    <label for="volumetrivweight" class="form-label">Volumetric Weight</label>
                                    <div class="form-check form-switch form-switch-md">
                                        <input type="checkbox" class="form-check-input"
                                            formControlName="switchVolumetricWeight" >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal"
                (click)="updateDiscountPeriod()" (keydown.enter)="useEnterKey ? $event.preventDefault() : updateDiscountPeriod()"
                    >Update</button>
            </div>
        </div>
    </div>
</form>